export const ContainerType = {
  Flex: 'flex',
  Grid: 'grid',
};

export const SectionFillType = {
  FullWidth: 'full-width',
  FullHeight: 'full-height',
  FillContainer: 'fill-container',
  Gapped: 'gapped',
};
